import React from 'react';
import './App.css';
import GaugeGallery from './TestComponent/GaugeGallery';

const App: React.FC = () => {
  return <GaugeGallery />;
};

export default App;
